<template>
  <div class="flex lg:w-[600px] flex-wrap justify-center mb-4">
    <div
      v-if="!loadJitsi"
      class="flex justify-center mb-5">
        <div
          class="spinner-border animate-spin inline-block w-8 h-8 border-4 rounded-full text-primary"
          role="status">
            <span class="visually-hidden">Carregando...</span>
        </div>
    </div>

    <div
      class="w-full h-[600px]"
      :class="{hidden: !loadJitsi}">
        <jitsi-meet
          v-if="this.appointmentStore.appointment?.id"
          :class="{hidden: !loadJitsi}"
          :options="jitsiOptions"
          ref="jitsiRef"
          @close-video="toolbarButtonClicked({ key: 'hangup' })">
        </jitsi-meet>
    </div>

    <button
      v-if="loadJitsi && !this.appointmentStore.appointment?.allow_return"
      class="hidden btn-primary font-normal text-xs px-4 py-2.5 mt-6"
      @click="openModalReturnAppointment()">
        Liberar Retorno
    </button>

    <modal-return
      ref="modalReturnAppointment"
      @confirm="returnAppointment" />

    <modal-confirm-hangup
      ref="modalConfirmHangup"
      @confirm="confirmHangup" />
  </div>
</template>

  <script>
  import { computed } from 'vue'
  import { usePage } from '@inertiajs/inertia-vue3'
  import JitsiMeet from '@/Shared/Components/JitsiMeet'
  import ModalReturn from '@/Shared/Modal/ModalReturn'
  import ModalConfirmHangup from '@/Shared/Modal/ModalConfirmHangup'
  import { useAppointmentStore } from '@/Store/Appointment'
  import { useNotificationStore } from '@/Store/Notification'


  export default {
    inject: ['patient', 'openAppointmentSide', 'closeAppointmentSide'],
    components: {
      JitsiMeet,
      ModalReturn,
      ModalConfirmHangup,
    },
    setup() {
      const user = computed(() => usePage().props.value.auth.user)
      return { user }
    },
    data() {
      return {
        appointmentStore: useAppointmentStore(),
        notificationStore: useNotificationStore(),
        loadJitsi: false,
        appointment: {},
      }
    },
    computed: {
      jitsiOptions () {
        return {
          roomName: this.appointmentStore.appointment?.id?.replaceAll('-', ''),
          jwt: this.appointmentStore.appointment?.jwt,
          lang: 'ptBR',
          noSSL: false,
          userInfo: {
              email: this.user.email,
              displayName: this.user.name,
          },
          configOverwrite: {
              toolbarButtons: [
                  'chat',
                  'fullscreen',
                  'raisehand',
                  'select-background',
                  'settings',
                  'toggle-camera',
                  'videoquality',
                  'hangup',
              ],
              buttonsWithNotifyClick: [
                {
                  key: 'hangup',
                  preventExecution: true,
                },
              ],
          },
          onload: this.onIFrameLoad
        };
      },
    },
    methods: {

      onIFrameLoad () {
        this.loadJitsi = true;

        this.$refs.jitsiRef.addEventListener('toolbarButtonClicked', this.toolbarButtonClicked);
        this.$refs.jitsiRef.addEventListener('readyToClose', this.closeConsultation);
        this.$refs.jitsiRef.addEventListener('participantJoined', atientEventData => this.handlePatientEnter(atientEventData.id))

        this.$refs.jitsiRef.addEventListener('largeVideoChanged', this.pinPatient)

        this.updateDate();
      },

      async pinPatient() {
        const rooms = await this.$refs.jitsiRef.getRominfo()

        const patientToPin = rooms.find(room => room.displayName == this.patient.user.name)
        this.$refs.jitsiRef.pinParticipant(patientToPin?.participantId)
      },

      handlePinPatient(id) {
        this.$refs.jitsiRef.pinParticipant(id)
      },

      toolbarButtonClicked(obj) {
        if(obj?.key === 'hangup') {
          if(document.fullscreenElement){
            document.exitFullscreen()
          }
          this.$refs.modalConfirmHangup.openModalConfirmHangup();
        }
      },
      closeConsultation() {
        this.appointmentStore.show_note = false;
        this.updateDate('out');
        this.loadJitsi = false;
        this.closeAppointmentSide();
        this.appointmentStore.setAppointment(null);
        usePage().props.value.auth.user.professional.now_appointment = null;
        this.notificationStore.start();
      },
      openRoom(item) {
        this.appointmentStore.setAppointment(item);
      },
      openModalReturnAppointment() {
        let appointment = this.appointmentStore.appointment;
        this.$refs.modalReturnAppointment.openModalReturn(appointment, `/patients/online-consultation/return/${item.id}`);
      },
      returnAppointment() {
        let appointment = this.appointmentStore.appointment;
        appointment.allow_return = true;
        this.appointmentStore.setAppointment(appointment);
      },
      updateDate(type = 'join') {
        let token = this.$page.props.csrf_token;
        return fetch(`/appointments/update-date-professional/` + this.appointmentStore.appointment.id, {
          method: 'PUT',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-Token': token
          },
          body: JSON.stringify({
            type: type,
          })
        });
      },
      confirmHangup() {
        this.$refs.jitsiRef.executeCommand('hangup');
      }
    },
    mounted () {
      this.appointmentStore.show_note = false;
    },
    unmounted() {
      this.appointmentStore.setAppointment(null);
    },
  }
  </script>
